import type { TOC } from '@ember/component/template-only'
import RouteTemplate from 'ember-route-template'
import type BookLibrarySharesByCollectionShowRoute from 'teacher-ui-client/subscription-type/book-library/shares/index/by-collection/show/route'
import type BookLibrarySharesByCollectionShowController from 'teacher-ui-client/subscription-type/book-library/shares/index/by-collection/show/controller'
import { BookLibraryShareStudentsTable } from 'teacher-ui-client/components/book-library/share-students-table'

interface Signature {
  Args: {
    model: ModelFor<BookLibrarySharesByCollectionShowRoute>
    controller: BookLibrarySharesByCollectionShowController
  }
}
export const BookLibrarySharesIndexByCollectionShowPage: TOC<Signature> = <template>
  <BookLibraryShareStudentsTable
    @subscriptionType={{@model.subscriptionType}}
    @studentsTask={{@controller.fetchStudentsForShare}}
  />
</template>

export default RouteTemplate(BookLibrarySharesIndexByCollectionShowPage)
